import React from "react";
import { Link } from "react-router-dom";

import { useSelector, useDispatch } from "react-redux";

import { Badge, MenuItem } from "@material-ui/core";
import AccountCircleIcon from "@material-ui/icons/AccountCircle";

import Analytics from "helpers/analytics";
import DropdownContainer from "../styles/dropdown.style";

import Dropdown from "../../shared/Dropdown";

function Categories(props) {
  const dispatch = useDispatch();
  const auth = useSelector((state) => state.auth);
  const agreements = auth?.userProfile?.agreements;
  const isInside = auth?.user?.roles?.includes("ROLE_INSIDER");
  const isRiff = auth?.user?.roles?.includes("ROLE_RIFF_USER");
  const searchPage = window.location.pathname.startsWith("/licensing/search");
  const searchTerms = useSelector((state) => state.pages.search.searchTerms);
  const search = useSelector((state) => state.pages.search);

  const handleSignOut = () => {
    if (searchPage) {
      Analytics.track("search_exit", {
        category: "LP_search",
        label: "LP_search_exits",
        search_type: searchTerms === "" ? "null search" : "keyword search",
        search_keyword: searchTerms,
        total_number_of_search_results: search?.pagination?.totalResults
      });
    }
  };

  return (
    <DropdownContainer>
      <Dropdown
        placement="bottom-end"
        text={<AccountCircleIcon />}
        analytics={() => {
          Analytics.track("My Account", {
            category: "LP-TopNav"
          });
        }}
        autoClose
      >
        <Link to="/licensing/account/lists">
          <MenuItem>
            Playlists <Badge className="playlist-count" badgeContent={props.playlist} />
          </MenuItem>
        </Link>
        <Link to="/licensing/account/profile">
          <MenuItem>Profile</MenuItem>
        </Link>
        <Link to="/licensing/account/history">
          <MenuItem>History</MenuItem>
        </Link>
        {isInside && (
          <Link to="/licensing/account/usage">
            <MenuItem>Insider Dashboard</MenuItem>
          </Link>
        )}

        {agreements && agreements.length > 0 && (
          <a href={window.partnerDashboard} target="_blank">
            <MenuItem>Partner Dashboard</MenuItem>
          </a>
        )}
        <div onClick={handleSignOut}>
          <MenuItem onClick={props.logout}>Sign Out</MenuItem>
        </div>
      </Dropdown>
    </DropdownContainer>
  );
}

export default Categories;
